
import makerjs from "makerjs";
function B26(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,T = Param[2].param,R = Param[3].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       t = T * 1 * myZoom,
        r = R * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = (b-t)/2, x1 = 0, x2 =0 ,x3 =(b-t)/2 ,x4 =b-(b-t)/2 ,x5 =b ,x6 =b ,x7 =b-(b-t)/2 , 
       y0 = 0, y1 = (l-r)/2,y2 =l-(l-r)/2, y3 =l,y4 =l,y5 =l-(l-r)/2,y6 =(l-r)/2,y7 =0,glassH =l, glassW = b,h=l,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  }  if (r !== 0) {
    var TxtR = "R="+R;
  }  if (t !== 0) {
    var TxtT = "T="+T;
  } 



   var drawAbnormalShapeB26 = {
       paths: {
        "LeftLine1": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "LeftLine2": new makerjs.paths.Line([x1, y1], [x2,y2]),
        "LeftLine3": new makerjs.paths.Line([x2,y2], [x3,y3]),
        "TopLine":new makerjs.paths.Line([x3,y3], [x4,y4]), 
        "RightLine1":new makerjs.paths.Line([x4,y4], [x5,y5]), 
        "RightLine2":new makerjs.paths.Line([x5,y5], [x6,y6]), 
        "RightLine3":new makerjs.paths.Line([x6,y6], [x7,y7]), 
        "BottomLine": new makerjs.paths.Line([x7,y7], [x0, y0]),
       }
   };
   var drawAbnormalShapeB26MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x1- markShift, y0], [x1- markShift, y3]),
        "RightShortUpline": new makerjs.paths.Line([x2, y3], [x2- 2 * markShift, y3]),
        "RightShortDnline": new makerjs.paths.Line([x1, y0], [x1- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeB26MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x5+ markShift, y5], [x6+ markShift, y6]),
        "RightShortUpline": new makerjs.paths.Line([x5, y5], [x5+ 2 * markShift, y5]),
        "RightShortDnline": new makerjs.paths.Line([x6, y6], [x6+ 2 * markShift, y6]),
       }
   };
   var drawAbnormalShapeB26MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x7, y7- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x7, y7], [x7, y7 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB26MarkT = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x3, y3+ markShift], [x4, y4+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x3, y3], [x3, y3 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x4, y4], [x4, y4 + 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB26MarkB, TxtB, [x0, y0 - 2 * markShift], [x7, y7 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB26MarkT, TxtT, [x3, y3+ 2*markShift], [x4, y4+ 2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB26MarkL, TxtL, [x1-2*markShift, y0], [x1-2*markShift, y3]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB26MarkR, TxtR, [x6+ 3*markShift, y6], [x5+ 3*markShift, y5]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB26: drawAbnormalShapeB26,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB26: drawAbnormalShapeB26,
        drawAbnormalShapeB26MarkL: drawAbnormalShapeB26MarkL,
        drawAbnormalShapeB26MarkT: drawAbnormalShapeB26MarkT,
        drawAbnormalShapeB26MarkR: drawAbnormalShapeB26MarkR,
        drawAbnormalShapeB26MarkB:drawAbnormalShapeB26MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B26;